import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-address-icon',
  templateUrl: './address-icon.component.html',
  styleUrls: ['./address-icon.component.css']
})
export class AddressIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
